<!--用户底部的控制面板-->

<template>
  <div :class="`panel ${isDashboard ? 'dash-control' : ''}`">
    <!-- Left Section: Navigation & Page Dots Indicator -->
    <div class="panel-left-section" v-if="!isVideoClassroom">
      <button class="panel-nav-btn" :disabled="currentPage <= 1" @click="lastPage()" title="Previous slide">
        <i class="el-icon-arrow-left"></i>
      </button>

      <div class="page-indicator">
        <span class="page-text">{{ currentPageIndex + 1 }} / {{ getPageNum }}</span>
        <div class="page-dots" v-if="getPageNum > 1">
          <span
            v-for="idx in Math.min(getPageNum, 10)"
            :key="idx"
            class="dot"
            :class="{active: (currentPageIndex + 1) === idx}"
            @click="changePage(idx)">
          </span>
        </div>
      </div>

      <button class="panel-nav-btn" :disabled="currentPage >= getPageNum" @click="nextPage()" title="Next slide">
        <i class="el-icon-arrow-right"></i>
      </button>
    </div>

    <!-- Center Section: Mode Pill with Dropdown Popup -->
    <div class="panel-center-section">
      <el-popover
        placement="top"
        trigger="click"
        popper-class="mode-popover-custom"
        v-model="modePopoverVisible"
        :visible-arrow="false">
        <div class="mode-menu-list">
          <div
            class="mode-menu-item"
            :class="{active: session.status === 'student'}"
            @click="selectMode('student')">
            <span class="custom-radio" :class="{checked: session.status === 'student'}">
              <span class="radio-inner" v-if="session.status === 'student'"></span>
            </span>
            <span class="mode-menu-text">Student Paced</span>
          </div>
          <div class="mode-menu-divider"></div>
          <div
            class="mode-menu-item"
            :class="{active: session.status !== 'student'}"
            @click="selectMode('teacher')">
            <span class="custom-radio" :class="{checked: session.status !== 'student'}">
              <span class="radio-inner" v-if="session.status !== 'student'"></span>
            </span>
            <span class="mode-menu-text">Teacher Paced</span>
          </div>
        </div>

        <div
          slot="reference"
          class="mode-pill"
          :class="{buttondisable: cantStopStudentPaced()}">
          <span class="mode-dot"></span>
          <span class="mode-label">Mode</span>
          <span class="mode-status">{{ session.status === 'student' ? 'Student Paced' : 'Teacher Paced' }}</span>
          <i :class="modePopoverVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="mode-arrow"></i>
        </div>
      </el-popover>
    </div>

    <!-- Right Section: Start Game, Game Analysis, Lock Screens, Show Responses -->
    <div class="panel-right-section">
      <!-- START GAME Button -->
      <button
        v-if="isDashboardMode && session.status !== 'close'"
        class="btn-start-game"
        @click="handleStartGameClick">
        <img src="@/assets/icon/gameicon.png" class="btn-icon" alt="" />
        <span>Start Game</span>
      </button>

      <!-- GAME ANALYSIS Button -->
      <button
        v-if="isDashboardMode && isAnalayisPresent"
        class="btn-game-analysis"
        @click="handleGameAnalysisClick">
        <img src="@/assets/icon/barGraph.png" class="btn-icon" alt="" />
        <span>Game Analysis</span>
      </button>

      <!-- Lock Screens -->
      <template v-if="getQuestion && getQuestion.type !== 'website' && !['student', 'close'].includes(session.status) && getPage.type !== 'video'">
        <div class="action-btn-stacked" :class="{active: isLockPage}" @click="dolockPage">
          <i :class="isLockPage ? 'el-icon-lock' : 'el-icon-unlock'" class="action-icon"></i>
          <span class="action-label">{{ isLockPage ? 'Unlock Screens' : 'Lock Screens' }}</span>
        </div>

        <div class="action-btn-stacked" :class="{active: isResponseShow}" @click="showRes">
          <i class="el-icon-s-platform action-icon"></i>
          <span class="action-label">{{ isResponseShow ? 'Hide Response(s)' : 'Show Response(s)' }}</span>
        </div>
      </template>

      <!-- New Prompt (if live) -->
      <div v-if="session.status == 'live'" class="action-btn-stacked" @click="showNewPrompt">
        <i class="fa el-icon-news action-icon"></i>
        <span class="action-label">New Prompt</span>
      </div>

      <!-- Video classroom display student name -->
      <div v-if="isVideoClassroom" class="action-btn-stacked" :class="{active: isShowStudentName}" @click="changeStudentName">
        <i class="fa action-icon" :class="isShowStudentName ? 'fa-eye' : 'fa-eye-slash'"></i>
        <span class="action-label">{{ isShowStudentName ? 'Hide Student Name' : 'Display Student Name' }}</span>
      </div>

      <!-- Non-dashboard response counter -->
      <div class="with-outer" v-if="!isDashboard">
        <i :class="`icon-circle ${current_response === 0 && 'red-icon'}`"></i>
        <strong>{{ current_response == 0 ? 'No' : current_response }} Response</strong>
      </div>
    </div>

    <AudioTranslate v-if="session.sid === 'C005GKHS9'" />
    <UploadEnter />
  </div>
</template>
<script>
import UploadEnter from '@/components/uploadFile/uploadEnter.vue'
import AudioTranslate from './AudioTranslate.vue'
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
export default {
  props: {
    currentPage: {type: Number, default: 1},
    isClosed: {type: Boolean, default: false},
    current_response: {type: Number, default: 0},
    turnModel: {type: Function},
    isDashboard: {type: Boolean, default: false},
    dashTipsModalVisiable: {type: Boolean, default: false},
    changePage: {type: Function},
    showNewPrompt: {type: Function},
    showDashTips: {type: Function},
    isVideoClassroom: {type: Boolean},
    getPage: {type: Object},
  },
  computed: {
    ...mapState(['session', 'countDown']),
    ...mapGetters(['getQuestion', 'getMaterial', 'isMaterialShow', 'isShowStudentName', 'getPageId', 'getPageNum']),
    ...mapState({
      currentPageIndex: (state) => state.student.currentPageIndex,
      currentVideoQuizId: (state) => state.student.currentVideoQuizId,
    }),
    isResponseShow() {
      return this.$store.getters['teacher/isResponseShow'](this.currentPageIndex)
    },
    isLockPage() {
      return this.$store.getters['teacher/isLocked'](this.currentPageIndex)
    },
    isDashboardMode() {
      const path = (this.$route && this.$route.path) || window.location.pathname
      return path.includes('/d/') || this.isDashboard
    },
  },
  components: {UploadEnter, AudioTranslate},
  data() {
    return {
      dialogVisible: false,
      countDownStatus: 0,
      statusList: {close: 'Closed', 'insturctor-paced': 'Teacher-Paced', live: 'Teacher-Paced', student: 'Student-paced'},
      isAnalayisPresent: false,
      modePopoverVisible: false,
    }
  },
  mounted() {
    if (window.countDownItCP) clearInterval(window.countDownItCP)
    window.countDownItCP = setInterval(() => {
      //this.countDownStatus = this.countDown.end === null ? 0 : Date.now() > this.countDown.end ? 2 : 1
      this.countDownStatus = this.session.countdown?.deadline == null ? 0 : Date.now() > new Date(this.session.countdown.deadline).getTime() ? 2 : 1
      if (this.countDownStatus === 2) this.showCountDown = true
      this.$forceUpdate()
    }, 1000)

    if (window.EventBus) {
      EventBus.$on('gameAnalysisStatusChanged', (status) => {
        this.isAnalayisPresent = !!status
      })
      EventBus.$emit('requestGameButtonStatus')
    }
  },
  beforeDestroy() {
    if (window.countDownItCP) clearInterval(window.countDownItCP)
    if (window.EventBus) {
      EventBus.$off('gameAnalysisStatusChanged')
    }
  },
  methods: {
    ...mapActions('teacher', ['showResponse', 'showMaterial', 'showStudentName']),
    changeMeterial() {
      if (this.isResponseShow) {
        this.showResponse([this.currentPageIndex, this.getPageId])
      }
      this.showMaterial([this.currentPageIndex, this.getPageId])
    },
    changeStudentName() {
      this.showStudentName(this.currentVideoQuizId)
    },
    async lockPage() {
      await this.$store.dispatch('teacher/lockPageBtn', this.currentPageIndex)
      this.$forceUpdate()
    },
    lastPage() {
      if (this.currentPage > 1) {
        let page = this.currentPage - 1
        this.changePage(page)
      }
    },
    nextPage() {
      if (this.currentPage < this.getPageNum) {
        let page = this.currentPage + 1
        this.changePage(page)
      }
    },
    cantStopStudentPaced() {
      //return this.countDownStatus || this.session.countdown?.studentCtrl ? true : false
      return this.countDownStatus || (this.session.countdown.type == 2 && this.session.sessionType == 'student') ? true : false
    },
    closeStudentPaced() {
      if (this.cantStopStudentPaced()) {
        this.$message.info('Student-pace cannot be stopped under Countdown/Deadline mode.')
      } else {
        this.turnModel()
      }
    },
    selectMode(targetMode) {
      this.modePopoverVisible = false
      if (targetMode === 'student') {
        if (this.session.status !== 'student') {
          this.turnModel()
        }
      } else if (targetMode === 'teacher') {
        if (this.session.status === 'student') {
          this.closeStudentPaced()
        }
      }
    },
    showRes() {
      if (this.isMaterialShow) {
        this.showMaterial([this.currentPageIndex, this.getPageId])
      }
      this.showResponse([this.currentPageIndex, this.getPageId])
      this.$forceUpdate()
    },
    dolockPage() {
      this.lockPage()
    },
    handleStartGameClick() {
      if (window.EventBus) {
        window.EventBus.$emit('triggerStartGame')
      } else if (window._ttt && window._ttt.handleStartGameClick) {
        window._ttt.handleStartGameClick()
      }
    },
    handleGameAnalysisClick() {
      if (window.EventBus) {
        window.EventBus.$emit('triggerGameAnalysis')
      } else if (window._ttt) {
        window._ttt.showGameAnalysis = true
      }
    },
  },
}
</script>
<style scoped>
strong {
  color: #36425a;
  font-size: 14px;
}
.panel {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 1.25rem;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.04);
}

.panel-left-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.panel-nav-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.panel-nav-btn:hover:not(:disabled) {
  border-color: #cbd5e1;
  color: #1e293b;
  background: #f8fafc;
}

.panel-nav-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.panel-nav-btn i {
  font-size: 13px;
  font-weight: bold;
}

.page-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 4px;
}

.page-text {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.page-dots {
  display: flex;
  align-items: center;
  gap: 5px;
}

.page-dots .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #cbd5e1;
  transition: all 0.2s ease;
  cursor: pointer;
}

.page-dots .dot.active {
  background: #10b981;
  transform: scale(1.15);
}

.panel-center-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mode-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f1f5f9;
  border-radius: 9999px;
  padding: 6px 14px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
}

.mode-pill:hover {
  background: #e2e8f0;
}

.mode-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #10b981;
}

.mode-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.mode-status {
  font-size: 13px;
  color: #1e293b;
  font-weight: 600;
}

.mode-arrow {
  font-size: 11px;
  color: #64748b;
  margin-left: 2px;
}

.panel-right-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-start-game {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 162px;
  height: 43px;
  padding: 8px 16px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 2px solid #C8C5FF;
  background: #635BFF;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 1px 2px 0px rgba(99, 91, 255, 0.20);
}

.btn-start-game i,
.btn-start-game .btn-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.btn-start-game:hover {
  background: #534be8;
  border-color: #dedcff;
  box-shadow: 0px 2px 4px 0px rgba(99, 91, 255, 0.30);
}

.btn-start-game:active {
  transform: translateY(1px);
}

.btn-game-analysis {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 43px;
  padding: 8px 14px;
  box-sizing: border-box;
  white-space: nowrap;
  border-radius: 12px;
  border: 1px solid #635BFF;
  background: #ffffff;
  color: #635BFF;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-game-analysis i,
.btn-game-analysis .btn-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.btn-game-analysis:hover {
  background: #f8f8ff;
  border-color: #534be8;
  color: #534be8;
}

.btn-game-analysis:active {
  transform: translateY(1px);
}

.action-btn-stacked {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 6px;
  cursor: pointer;
  color: #475569;
  transition: all 0.2s ease;
  user-select: none;
}

.action-btn-stacked:hover {
  background: #f8fafc;
  color: #1e293b;
}

.action-btn-stacked.active {
  color: #10b981;
}

.action-btn-stacked.active .action-icon {
  color: #10b981;
}

.action-icon {
  font-size: 18px;
  margin-bottom: 2px;
}

.action-label {
  font-size: 10.5px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}
.svg_right {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.control-bar__button,
.control-bar__button--large,
.control-bar__button--lock {
  display: block;
  position: relative;
  height: auto;
  padding: 0.5em;
  background-color: transparent;
  border: 0px solid transparent;
  opacity: 1;
  text-align: center;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  cursor: pointer;
}
.control-bar__button {
  padding: 0.5rem 1rem;
}
.control-bar__icon {
  width: 13.34px;
  height: 24px;
  background-size: contain;
  background-position: 0 0;
  background-repeat: no-repeat;
}
.control-bar__icon.left {
  background-image: url(../../assets/picture/arrow-r.png);
}
.control-bar__icon.right {
  background-image: url(../../assets/picture/arrow-l.png);
}
.dash-tip {
  display: none;
  background-image: url(../../assets/picture/dash-tip.png);
}
.more-pop {
  background-image: url(../../assets/picture/more-pop.png);
}

.control-bar__icon:hover {
  fill: #c0c0c0;
}

.control-bar__button--large {
  min-width: 4.375em;
  min-height: 50px;
}

.control-bar__label {
  position: relative;
  display: none;
  font-size: 13px;
  color: #36425a;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.icon {
  fill: #36425a;
  cursor: pointer;
}
.icon:hover {
  fill: antiquewhite;
}
.icon_left {
  margin-left: 20px;
}
.pageIndex {
  color: #36425a;
  font-size: 20px;
  height: 50px;
  display: flex;
  align-items: center;
}

.dropdown-icon {
  width: 20px;
  height: 40px;
  display: flex;
  bottom: 10px;
  line-height: 40px;
  overflow: hidden;
  margin-right: 10px;
  margin-left: 20px;
}
.end_button {
  width: 40px;
  height: 40px;
  display: flex;
  bottom: 10px;
  line-height: 40px;
  overflow: hidden;
  margin-right: 20px;
  color: #36425a;
  cursor: pointer;
  font-size: 14px;
}

.info_area {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
}
.info_area.video {
  justify-content: flex-start;
}

.hide_area {
  visibility: hidden;
}

.back_focus {
  background-color: #15c39a99;
  border-radius: 8px;
}
.icon-circle {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  display: inline-block;
  margin-right: 3px;
  background-color: #36425a;
}
.icon-circle.red-icon {
  background-color: #ff1a0e;
}
.icon-circle.green-icon {
  background-color: rgba(21, 195, 154, 1);
}
.with-outer {
  padding: 3px 13px;
  border-radius: 16px;
  background-color: rgba(54, 66, 90, 0.1);
  margin-right: 0.5rem;
}
.buttondisable {
  opacity: 0.4;
}

.mode-menu-list {
  display: flex;
  flex-direction: column;
  padding: 2px 0;
  user-select: none;
}

.mode-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.mode-menu-item:hover {
  background-color: #f8fafc;
}

.custom-radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  box-sizing: border-box;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.custom-radio.checked {
  border: 2px solid #10b981;
}

.custom-radio .radio-inner {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #10b981;
}

.mode-menu-text {
  font-size: 13.5px;
  font-weight: 500;
  color: #1e293b;
  white-space: nowrap;
}

.mode-menu-divider {
  height: 1px;
  background-color: #f1f5f9;
  margin: 2px 0;
}
</style>

<style>
.mode-popover-custom {
  padding: 6px 0 !important;
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1) !important;
  min-width: 175px !important;
  margin-top: -15px !important;
}
.mode-popover-custom .popper__arrow {
  display: none !important;
}
</style>
